export const directions = {
  t: 'bg-gradient-to-t',
  r: 'bg-gradient-to-r',
  b: 'bg-gradient-to-b',
  l: 'bg-gradient-to-l',
  tr: 'bg-gradient-to-tr',
  tl: 'bg-gradient-to-tl',
  br: 'bg-gradient-to-br',
  bl: 'bg-gradient-to-bl',
}
